<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M15.5747 9.60964C15.0997 9.48464 14.5414 9.41797 13.8747 9.41797C12.9497 9.41797 12.6081 9.64297 12.1331 10.0013C12.1081 10.018 12.0831 10.043 12.0581 10.068L11.2664 10.9096C10.5997 11.6096 9.39975 11.618 8.73308 10.9013L7.94141 10.068C7.91641 10.043 7.89141 10.018 7.86641 10.0013C7.39141 9.64297 7.04974 9.41797 6.12474 9.41797C5.45807 9.41797 4.89974 9.48464 4.42474 9.60964C2.44141 10.143 2.44141 11.718 2.44141 13.1013V13.8763C2.44141 15.968 2.44141 18.3346 6.89974 18.3346H13.0997C16.0581 18.3346 17.5581 16.8346 17.5581 13.8763V13.1013C17.5581 11.718 17.5581 10.143 15.5747 9.60964ZM11.9414 15.3346H8.05807C7.74141 15.3346 7.48307 15.0763 7.48307 14.7513C7.48307 14.4263 7.74141 14.168 8.05807 14.168H11.9414C12.2581 14.168 12.5164 14.4263 12.5164 14.7513C12.5164 15.0763 12.2581 15.3346 11.9414 15.3346Z"
      fill="currentColor"
    />
    <path
      d="M10.5583 3.58464L11.1 4.1263C11.3166 4.34297 11.675 4.34297 11.8916 4.1263C12.1083 3.90964 12.1083 3.5513 11.8916 3.33464L10.3916 1.83464C10.3416 1.78464 10.275 1.74297 10.2083 1.70964C10.1416 1.68464 10.075 1.66797 9.99997 1.66797C9.92497 1.66797 9.8583 1.68464 9.7833 1.70964C9.71663 1.73464 9.66663 1.7763 9.61663 1.81797C9.6083 1.8263 9.6083 1.8263 9.59997 1.8263L8.1 3.33464C7.88333 3.5513 7.88333 3.90964 8.1 4.1263C8.31667 4.34297 8.67497 4.34297 8.89163 4.1263L9.4333 3.58464V5.0013H10.5583V3.58464Z"
      fill="currentColor"
    />
    <path
      d="M16.0089 8.43333C15.9756 8.41667 15.9339 8.40833 15.9006 8.4H15.8922C15.3006 8.24167 14.6422 8.16667 13.8756 8.16667C12.5922 8.16667 11.9839 8.54167 11.4339 8.95833C11.3172 9.04167 11.2339 9.125 11.1506 9.20833L10.3589 10.05C10.2756 10.1333 10.1422 10.1833 10.0006 10.1833C9.95055 10.1833 9.76722 10.175 9.64222 10.0417L8.82555 9.18333C8.74222 9.09167 8.64222 9.01667 8.61722 9C8.01719 8.54167 7.40885 8.16667 6.12552 8.16667C5.35885 8.16667 4.70052 8.24167 4.10052 8.4C4.06719 8.40833 4.02552 8.41667 3.99219 8.43333C4.00052 6.775 4.16719 5 7.67552 5H9.44222V7.56667C9.44222 7.875 9.69222 8.125 10.0006 8.125C10.3089 8.125 10.5589 7.875 10.5589 7.56667V5H12.3256C15.8339 5 16.0006 6.775 16.0089 8.43333Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'DirectMessagesIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>